export default __webpack_public_path__ + "static/media/filter.68c06116.svg";